import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interior-office',
  templateUrl: './interior-office.component.html',
  styleUrls: ['./interior-office.component.css']
})
export class InteriorOfficeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/interior/interior-office/interior-office.component.ts